export default "__VITE_ASSET__BaHSPtWM__"